import { useState } from "react";
import MessageContainer from "./MessageContainer";
import MessageFooter from "./MessageFooter";
import { Dialog, DialogContent } from "../../../tailwind/dialog";

export default function ImageMessage({ message }) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const { content, direction, status, createdAt } = message;
  const isOutbound = direction === "OUTBOUND";

  const imageUrl = content.media?.link;

  if (!imageUrl) {
    return null;
  }

  return (
    <MessageContainer isOutbound={isOutbound} className="p-0 overflow-hidden">
      <div className="relative">
        {isLoading && (
          <div className="w-48 h-48 bg-gray-200 dark:bg-slate-700 flex items-center justify-center">
            <span className="text-xs text-gray-500">Loading...</span>
          </div>
        )}
        {!hasError ? (
          <button
            type="button"
            className="block rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-[#dcf8c6] dark:focus:ring-offset-slate-900"
            onClick={() => setIsPreviewOpen(true)}
            aria-label="Open image preview"
          >
            <img
              src={imageUrl}
              alt="Message image"
              className="w-48 h-auto rounded-lg cursor-zoom-in"
              onLoad={() => setIsLoading(false)}
              onError={() => {
                setIsLoading(false);
                setHasError(true);
              }}
            />
          </button>
        ) : (
          <div className="w-48 h-48 bg-gray-200 dark:bg-slate-700 flex items-center justify-center">
            <span className="text-xs text-gray-500">Failed to load image</span>
          </div>
        )}
      </div>
      <MessageFooter status={status} timestamp={createdAt} isOutbound={isOutbound} className="px-2 pb-2" />

      <Dialog open={isPreviewOpen} onOpenChange={setIsPreviewOpen}>
        <DialogContent className="max-w-[92vw] sm:max-w-4xl p-2 sm:p-3 bg-transparent border-0 shadow-none">
          <div className="rounded-lg overflow-hidden bg-black/90">
            <img
              src={imageUrl}
              alt="Full size message image"
              className="max-h-[85vh] w-auto max-w-full object-contain mx-auto"
            />
          </div>
        </DialogContent>
      </Dialog>
    </MessageContainer>
  );
}
